import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import styles from './FacetChip.module.scss'

type FacetChipProps = {
  label: React.ReactNode
  score: number
  fullWidth?: boolean
  description?: React.ReactNode
  className?: string
}

const COLUMN_CLASSES = [styles.low, styles.medium, styles.high]

const getLevelLabel = score => {
  const index = Math.min(Math.floor(score / 33.3), 2)

  return [t`low`, t`medium`, t`high`][index]
}

export const FacetChip = ({
  label,
  score,
  fullWidth = false,
  description,
  className,
}: FacetChipProps) => {
  const chipHeader = (
    <>
      <div className={styles.chipLabel}>{label}</div>
      <div className={styles.chipScore}>{getLevelLabel(score)}</div>
      <div className={styles.chipGraph}>
        {COLUMN_CLASSES.map((columnClass, index) => (
          <div
            key={columnClass}
            className={cx(styles.graphColumn, columnClass, {
              [styles.selected]: score > index * 33.3,
            })}
          />
        ))}
      </div>
    </>
  )

  return (
    <div
      className={cx(
        styles.chip,
        {
          [styles.fullWidth]: fullWidth,
          [styles.withDescription]: description,
        },
        className,
      )}
    >
      {description ? (
        <div className={styles.chipHeader}>{chipHeader}</div>
      ) : (
        chipHeader
      )}
      {description && (
        <div className={styles.chipDescription}>{description}</div>
      )}
    </div>
  )
}
